import React from "react";

import baseRoutes from "@in-core/incore-playbook/src/routes";
import {HelloWorld} from "./components/HelloWorld";
import {NotFound} from "@in-core/incore-playbook/src/components/NotFound";

const aggregatedRoutes = Object.assign(baseRoutes, {
	// example of adding more routes
	"/hello-world": {
		exact: false,
		component: HelloWorld
	},
	// fallback
	"*": {exact: false, component: NotFound},
});

export default aggregatedRoutes;

